/* track-events.js */
import trackAction from './utils/action';
/**
 * actionCount
        点击,查看次数
        duration
        当elementAction是Time on Page，Time on Tab，页面停留时间
        elementAction元素动作，
        点击：Views,Search Results,Details Clicks,Select Now Clicks,Phone Clicks,Favourited,Shares,Tab Views,停留时间：Time on Page,Time on Tab,
        elementName
        当elementAction是Tab Views,Time on Tab下面的二级元素
        endTime
        当elementAction是Time on Page，Time on Tab，离开页面时间
        propertyId
        房产ID
        startTime
        当elementAction是Time on Page，Time on Tab，进入页面时间
 */
export default {
    /**
     * @name TONP 固定名称不支持修改
     * @desc 页面停留时间埋点（Time on Page）
     * @param {Object} context 当前上下文
     * @param {Timestamp} et 进入页面时间
     * @param {Timestamp} dt 离开页面时间
     */
    TONP({ $route }, { et, dt }) {
        if (!$route) return
        const actionInfo = {
            "actionCount": 0,
            "duration": 0,
            "elementAction": "",
            "elementName": "",
            "endTime": 0,
            "propertyId": $route.query.pid,
            "startTime": 0
        }
        if ($route.name === 'propertyDetailsIndex') { // 详情停留
            actionInfo.elementAction = 'Time on Page'
            actionInfo.duration = ((dt - et) / 1000).toFixed(0)
            actionInfo.startTime = dt
            actionInfo.endTime = et
            trackAction("停留", actionInfo);
        }
    },
    /**
     * @name 100 埋点唯一标识ID（自定义）
     * @param {Object} context 当前上下文
     * @param {Object} args 剩余参数
     */
    100({ $route: { query } }) {
        //Views
        trackAction("Views", {
            "actionCount": 1,
            "duration": 0,
            "elementAction": "Views",
            "elementName": "",
            "endTime": 0,
            "propertyId": query.pid,
            "startTime": 0
        });
    },
    101({ $route: { query } }) {
        //Select Now Clicks
        trackAction("Select Now", {
            "actionCount": 1,
            "duration": 0,
            "elementAction": "Select Now Clicks",
            "elementName": "",
            "endTime": 0,
            "propertyId": query.pid,
            "startTime": 0
        });
    },
    102({ $route: { query } }) {
        //Phone Clicks
        trackAction("Phone Clicks", {
            "actionCount": 1,
            "duration": 0,
            "elementAction": "Phone Clicks",
            "elementName": "",
            "endTime": 0,
            "propertyId": query.pid,
            "startTime": 0
        });
    },
    103({ $route: { query } }) {
        //Favourited
        trackAction("Favourited", {
            "actionCount": 1,
            "duration": 0,
            "elementAction": "Favourited",
            "elementName": "",
            "endTime": 0,
            "propertyId": query.pid,
            "startTime": 0
        });
    },
    104({ $route: { query } }) {
        //Shares
        trackAction("Shares", {
            "actionCount": 1,
            "duration": 0,
            "elementAction": "Shares",
            "elementName": "",
            "endTime": 0,
            "propertyId": query.pid,
            "startTime": 0
        });
    },
};



// WEBPACK FOOTER //
// ./src/track-events.js